import { LatestTermsOfUse } from 'types/latest-terms-of-use';

export const initialState: TermsState = {
  optelTerms: {
    id: 'initial-state-id',
    content: 'This content should not be shown.\nIf you see this, decline it and log back into Certa.\n' +
      'Please contact certa.support@optelgroup.com.',
    isAccepted: false
  },
  nmvsTerms: {
    id: 'initial-state-id',
    content: 'This content should not be shown. If you see this, decline it and log back into Certa.\n' +
      'Please contact certa.support@optelgroup.com.',
    isAccepted: false
  },
};

export interface TermsState {
  optelTerms: LatestTermsOfUse;
  nmvsTerms: LatestTermsOfUse;
}


// WEBPACK FOOTER //
// ./src/pages/terms-of-use/state.ts